module.exports = __webpack_public_path__ + "img/practical-go-lessons-book-review-mobi2.11446e77.png";